const paginationData = (state = {}, action) => {
  switch (action.type) {
  case 'SET_PAGINATION_DATA':
    return action.payload;
  case 'ADD_PAGINATION_DATA':
    return { ...state, [action.payload.type]: action.payload.data };
  default:
    return state;
  }
};

export default paginationData;
